module.exports = __webpack_public_path__ + "assets/img/no_prize.2155d386.png";